module.exports = __webpack_public_path__ + "img/2d5e9f5.jpg";